module.exports = __webpack_public_path__ + "media/images/home/disappointed-6d2127b8af7ce3125703183f1f7e94a4.png";